import React, {Component} from 'react';
import {Col, Row} from 'reactstrap';
import {SecondaryNavigation} from 'customers/SecondaryNavigation';

export class DetailContainer extends Component {
    render() {
        return (
            <Row>
                <Col sm={2}>
                    <SecondaryNavigation vertical hr id={this.props.id}/>
                </Col>
                <Col className={'offset-sm-1 col-sm-8 mt-3'}>
                    {this.props.children}
                </Col>
            </Row>
        )
    }
}
